// extracted by mini-css-extract-plugin
export default {"companyFinanceViewAdmin":"CompanyFinancePanel_companyFinanceViewAdmin__K6JE7"};